var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"c-content__login fill-height"},[_c('v-row',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.branding.primaryColor,"elevation":"16","fab":"","loading":"","x-large":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }